<template>
    <div class="card shadow p-3">
        <div class="card-header">
            <div class="row d-flex align-items-center">
                <span class="material-symbols-outlined text-primary rounded-circle icon bg-soft-primary">
                    lightbulb_2
                </span>
                <h4 class="col-3 d-inline"> {{ $trans.get("__JSON__.Site listing") }}</h4>
                <div class="col"></div>
                <input v-model="filter" type="text" class="form-control col-2" placeholder="Search" aria-label="Search"
                    aria-describedby="basic-addon1">
                <button @click="filter_it" class="btn btn-primary-lighter col-1 ml-1">
                    <span v-if="!filtered" class="material-symbols-outlined align-middle">
                        search
                    </span>
                    <span v-if="filtered" class="material-symbols-outlined align-middle">
                        search_off
                    </span>
                </button>
            </div>
            <div class="row">
                <div class="col-11">

                </div>
                <div class="col-1 align-end">
                    <button type="button" class="btn btn-secondary-ligther" @click="backToMyHome">
                        <span class="material-symbols-outlined align-middle">
                            home
                        </span>
                    </button>
                </div>
            </div>
        </div>

        <div class="card-body">
            <div class="m-2">
                <div class="row fs-6" style="font-weight: bold;">
                    <div class="col-2">
                        {{ $trans.get("__JSON__.Category") }}
                    </div>
                    <div class="col-2">
                        {{ $trans.get("__JSON__.Site name") }}
                    </div>
                    <div class="col-2">
                        {{ $trans.get("__JSON__.Created on") }}
                    </div>
                    <div class="col-2">
                        {{ $trans.get("__JSON__.Updated on") }}
                    </div>
                    <div class="col-4">
                        {{ $trans.get("__JSON__.Actions") }}
                    </div>
                </div>

                <div v-for="webpage, index in myWebpages" :key="webpage.id" class="row fs-6 border-top border-bottom"
                    :class="{ 'bg-light': (index % 2) == 0 }">
                    <div class="col-2 d-flex align-items-center">
                        {{ webpage.category.name }}
                    </div>
                    <div class="col-2 d-flex align-items-center">
                        {{ webpage.name }}
                    </div>
                    <div class="col-2 d-flex align-items-center">
                        {{ toDateTimeFormat(webpage.created_at) }}
                    </div>
                    <div class="col-2 d-flex align-items-center">
                        {{ toDateTimeFormat(webpage.updated_at) }}
                    </div>
                    <div class="col-4">
                        <div class="row">
                            <div class="col-3 d-flex align-items-center py-1 px-1">
                                <open-modal-button class="newspage-button" :view_icon=true :id="'btn_' + webpage.id"
                                    :key="'btn_' + webpage.id" :modal_to_open="'modal_' + webpage.id"
                                    button_denomination='show' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-for="webpage, index in myWebpages">
                <iframe-modal :id="'modal_' + webpage.id" :key="'modal_' + webpage.id"
                    :source="webpage.pagebuilder_page_translations[0]['route']" />
            </div>
        </div>
    </div>
</template>

<script>
import getMyWebpages from "../composables/webpages";
import { luxonParseDate } from "../transformDate";

export default {
    name: "MyWebsiteDirectory",

    props: {

    },
    setup() {
        const { myWebpages, myWebpages_error, loadMyWebpages } = getMyWebpages();
        loadMyWebpages(null, 'withoutNews');
        return { myWebpages, myWebpages_error, loadMyWebpages };
    },
    data() {
        return {
            filter: null,
            filtered: false,
        };
    },
    watch: {
    },
    computed: {

    },
    created() {

    },
    methods: {
        toDateTimeFormat(date) {
            let newDate = luxonParseDate(date).toFormat('yyyy-MM-dd HH:mm:ss');
            return newDate;
        },
        filter_it() {
            if (this.filtered == false) {
                this.loadMyWebpages(this.filter, 'withoutNews')
            }
            else {
                this.filter = null;
                this.loadMyWebpages(null, 'withoutNews')
            }
            this.filtered = !this.filtered;
        },
        backToMyHome() {
            console.log('back home clicked');
            window.location.href = '/my/home';
        },
    }
};
</script>